import { Injectable } from '@angular/core';
import { Headers } from '@angular/http';
import { HttpService } from '../http/http.service';
import { SigninResponseVO, SigninRequestVO } from "./signin.models";
import { SigninService } from './signin.service';
import { environment } from "../../environments/environment"
import { SsoService } from '../sso/sso.service';
import { ApplicationError } from '../common/error.model';
import * as crypto from "crypto";

const ENCRYPTION_ALGO = 'aes-128-cbc';
const INP_ENCODING = "utf8";
const OUT_ENCODING = "base64";
const PUB_KEY = `
-----BEGIN PUBLIC KEY-----
MIIBIjANBgkqhkiG9w0BAQEFAAOCAQ8AMIIBCgKCAQEAuAlPPkWh702gjpZKTb6v
1x7EX1nILl0fLpPAB0cFIHqa65xmxA9OAtbYY6cW0VETaIRo+LM0UJ/3Sz6MCHea
jiPJ6UlgOxo3LFep5/f8hU7IDZwUeVXYwpnV8MSEbbfwvcCsHRT2opsEDGx+j+7Z
jirOVHSrOp6HSZfh21gMyq5Q7GPvrkrX3gROOR0vDyvH0i7/IVG/esRhTaFiX8Zg
fhTzOiKyx8bNdHpj42mwhUAYQnx5L35ISI3m4bFw8XpcEfx+1+HRR05MFX9uVYxF
JYcc1UH5IErzReQ3eL4jWBndDWK2+YBwtugyls2aY9K7NQfJuwMBIY6HEVKjKGBa
HQIDAQAB
-----END PUBLIC KEY-----`;

@Injectable()
export class SigninServiceImpl implements SigninService {
  
  requestResetLinkMail(username: string): Promise<void> {
    let url = `${environment.SSO_API_ENDPOINT}/signin/forgotPassword?email=`+encodeURIComponent(username);
    console.log('url = ' + url);
    let headers = new Headers({
      'Authorization': 'None '
    });
    return this.httpService.get(url, headers).toPromise()
    .then(responseEnvelope => {
      console.log("Mail sent successfully");
    }, error => {
      console.error("Error received in signin service. " + JSON.stringify(error));
      throw error;
    });
  }

  constructor(private httpService: HttpService, private ssoService: SsoService) { }

  signin(signInVO: SigninRequestVO): Promise<SigninResponseVO> {
    let url = `${environment.SSO_API_ENDPOINT}/signin`;
    
    const key = crypto.randomBytes(16).toString('base64');
    const iv = crypto.randomBytes(16).toString('base64');

    const authData = this.encryptWithAES(btoa(`${signInVO.getUsername()}:${signInVO.getPassword()}`), key, iv);
    const signature = this.encryptWithPublicKey(`${key}:${iv}`);

    let headers = new Headers({
      'Authorization': `${authData}:${signature}`
    });

    this.ssoService.clear();

    return this.httpService.post(url, {}, headers).toPromise()
      .then(responseEnvelope => {
        let signInResponseVO: SigninResponseVO = null;
        if (responseEnvelope) {
          signInResponseVO = new SigninResponseVO(responseEnvelope.getBody());
          this.ssoService.saveSigninResponse(signInResponseVO);
        } else {
          console.error("Resposne received from signin REST service is empty. " + responseEnvelope);
          throw new ApplicationError("INVALID_SIGNIN_RESPONSE", "Signin failed", null);
        }
        return signInResponseVO;
      }, error => {
        console.error("Error received in signin service. " + JSON.stringify(error));
        throw error;
      });
  }

  encryptWithAES(message: string, key: string, iv: string) {

    const decodedKey = Buffer.from(key, 'base64');
    const decodedIV = Buffer.from(iv, 'base64');
    const cipher = crypto.createCipheriv(ENCRYPTION_ALGO, decodedKey, decodedIV);
    let encrypted = cipher.update(message, INP_ENCODING, OUT_ENCODING);
    encrypted += cipher.final(OUT_ENCODING);
    return encrypted;

  }

  encryptWithPublicKey(message: string) {

    const publicKeyPayload = {
      key: PUB_KEY,
      passphrase: '',
      padding: 1
    }

    const encryptedText = crypto.publicEncrypt(
      publicKeyPayload,
      Buffer.from(message, 'utf8')
    );
  
    return encryptedText.toString('base64');

  }

}




// WEBPACK FOOTER //
// ./src/app/signin/signin.service.impl.ts